import GuidesHero from "./components/hero/index.vue";
import GuidesTextBlock from "./components/text-block/index.vue";
import GuidesTrendBook from "./components/trendbook/index.vue";
import GuidesList from "./components/list/index.vue";
import { mapActions } from "vuex";
import { globalLoader } from "@/helpers/variables";

export default {
    name: "GuidesPage",
    props: {},
    emits: [],
    components: { GuidesList, GuidesTrendBook, GuidesTextBlock, GuidesHero },
    setup() {},
    data() {
        return {}
    },
    async created() {
        globalLoader(true)
        await this.fetchGuidesPage();
        globalLoader(false)
    },
    mounted() {},
    watch: {},
    computed: {},
    methods: {
        ...mapActions({
            fetchGuidesPage: "guides/FETCH_GUIDES_PAGE",
        })
    }
}
